import { ProductCalculationList, ProductQuantity } from 'api-client'

import { request } from './request'

export const fetchPricesAndOrderAmounts = async (
  baseUrl: string,
  productQuantities: ProductQuantity[],
  customerContextId: string,
  shipToLocationId: string,
) => {
  try {
    const { data } = await request<ProductCalculationList>({
      data: { productQuantityList: productQuantities },
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      params: {
        'filter[customerContextProducts.customerContext.id.equals]': customerContextId,
        'filter[pricePoint.ship_to.id.equals]': shipToLocationId,
      },
      url: `${baseUrl}/api/cart/calculation`,
    })

    return data.productCalculationList
  } catch {
    return []
  }
}
